import { api_without_cancellation as api } from "./api";

const brandingRequests = new Map();

// One lookup per slug per document, including remounts and password-reset steps.
export const getFirmLoginBranding = (slug) => {
  if (!brandingRequests.has(slug)) {
    brandingRequests.set(
      slug,
      api.get(`/api/firm-login/${slug}/`, { skipAuth: true }).then(({ data }) => data)
    );
  }
  return brandingRequests.get(slug);
};
